import axios from 'axios';
import * as Sentry from '@sentry/react';

const client = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});

client.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
client.defaults.xsrfCookieName = 'csrftoken';

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error?.response) {
      if (error?.response?.status === 403) {
        return Promise.reject(error);
      }
      Sentry.captureException(
        new Error(
          `Axios Request Failed. URL: ${
            error?.response?.config?.url || 'Unknown'
          }. Status: ${error?.response?.status || 'Unknown'}.`
        ),
        {
          contexts: {
            config: error?.config || {},
            response: error?.response || {}
          },
          fingerprint: [
            'axios',
            String(error?.response?.url),
            String(error?.response?.status)
          ]
        }
      );
    }

    return Promise.reject(error);
  }
);

export default client;
